export default {
  filePrefix: `${
    process.env.NODE_ENV === "production"
      ? `${process.env.WXCONSOLE_CLOUD_STORAGE_PATH}/wx-torch-frontend/frontend-asset/${process.env.WXCONSOLE_CLOUD_STORAGE_VERSION}`
      : ""
  }`,
};
